import { fabric } from "@utils/fabric";
import { TypeItalic } from "react-bootstrap-icons";
import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";

function FontItalic({
  disabled = false,
  onChange = () => {},
}: {
  disabled: boolean;
  onChange: () => void;
}) {
  const { selectedObject } = useContext(AppContext);
  const [fontStyle, setFontStyle] = useState(
    (selectedObject as fabric.Textbox)?.fontStyle
  );

  // triggered by clicking layers
  useEffect(() => {
    setFontStyle((selectedObject as fabric.Textbox)?.fontStyle);
  }, [selectedObject]);

  function onClick() {
    const newFontStyle = fontStyle === "normal" ? "italic" : "normal";
    setFontStyle(newFontStyle);
    (selectedObject as fabric.Textbox)?.set({ fontStyle: newFontStyle });

    // notify parent to load font and update canvas
    onChange();
  }

  return (
    <button
      disabled={disabled}
      className={`flex items-center justify-center h-9 w-9 rounded-lg border transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${
        fontStyle === "italic" 
          ? "bg-blue-500 border-blue-500 text-white shadow-sm" 
          : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400"
      }`}
      onClick={onClick}
    >
      <TypeItalic size={16} />
    </button>
  );
}

export default FontItalic;
